import EligibilityRoot from './Eligibility.root';

export const eligibility = {
    Component: EligibilityRoot,
};
